import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { NavbarComponent } from './navbar.component';
import { AudioSettingsComponent } from './audio-settings/audio-settings.component';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import {
  OperatorStatusButtonComponent
} from './operator-status-buttons/operator-status-button/operator-status-button.component';
import { OperatorStatusButtonsComponent } from './operator-status-buttons/operator-status-buttons.component';
import { OperatorStatusService } from 'shared/services/operator-status/operator-status.service';
import { AccessibilitySettingsComponent } from './accessibility-settings/accessibility-settings.component';
import { ModalDialogModule } from 'shared/components/modal-dialog/modal-dialog.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  NavbarScrollableDropdownComponent
} from './shared/navbar-scrollable-dropdown/navbar-scrollable-dropdown.component';
import {
  NavbarStatusDropdownItemComponent
} from './shared/navbar-status-dropdown-item/navbar-status-dropdown-item.component';
import { GenesysPresenceButtonComponent } from './genesys-presence-button/genesys-presence-button.component';
import { IfFeatureEnabledModule } from 'shared/directives/if-feature-enabled';
import { UserMenuButtonComponent } from './user-menu-button/user-menu-button.component';
import {
  MenuFocusHandlerDirective,
  MenuFocusTargetDirective,
  MenuFocusParentDirective
} from './shared/menu-focus-handler';
import { CustomPipesModule } from 'shared/pipes/custom-pipes.module';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';
import { GenesysUserPermissionCheckModule } from 'shared/directives/genesys-user-permission-check';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild(),
    ModalDialogModule,
    MatTooltipModule,
    IfFeatureEnabledModule,
    CustomPipesModule,
    TooltipModule,
    GenesysUserPermissionCheckModule
  ],
  providers: [
    OperatorStatusService
  ],
  declarations: [
    AudioSettingsComponent,
    LanguageSelectorComponent,
    OperatorStatusButtonComponent,
    OperatorStatusButtonsComponent,
    NavbarComponent,
    AccessibilitySettingsComponent,
    NavbarScrollableDropdownComponent,
    NavbarStatusDropdownItemComponent,
    GenesysPresenceButtonComponent,
    UserMenuButtonComponent,
    MenuFocusHandlerDirective,
    MenuFocusTargetDirective,
    MenuFocusParentDirective
  ],
  exports: [
    NavbarComponent
  ]
})
export class NavbarModule {
}
